import React from "react";
import { Helmet } from "react-helmet";
import NavTop2Component from "../../components/user/NavTop2Component";
import LandingNavbar from "../../components/user/LandingNavbar";
import LandingHeaderNCR from "../../components/user/LandingHeaderNCR";
import LandingPriceNcrPagePriceComponent from "../../components/user/LandingPriceNcrPagePriceComponent";
import LandingPackageComponent from "../../components/user/LandingPackageComponent";
import ContactButtons from "../../components/user/ContactButtons";
import LandingFooterComponent from "../../components/user/LandingFooterComponent";

const LandingPageNcrSecond = () => {
  return (
    <div>
      <div className="landing-page landing-page-backup">
        <Helmet>
          <title>Male beauty and waxing service at home in Delhi NCR</title>

          <meta
            name="description"
            content={`
              Book Glazma online male beauty and waxing service at home in Delhi NCR. Get best men's grooming and waxing service by professional groomers.
          `}
          />

          <meta
            name="keywords"
            content={`
          Men's grooming home service
          `}
          />
        </Helmet>

        <div className="landing-page-navbar">
        <NavTop2Component />
        <LandingNavbar 
        backupPage={true}
        />
        </div>

        <LandingHeaderNCR 
        backupPage={true}
        location="Delhi NCR" />

          <div>
            <LandingPriceNcrPagePriceComponent />
          </div>

        <div>
          <LandingPackageComponent />
        </div>

        <LandingFooterComponent  backupPage={true} />

        <ContactButtons />
      </div>
    </div>
  );
};

export default LandingPageNcrSecond;
